import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer } from '../Reusable'

import FadeIn from 'react-fade-in';
import ContactDetails from './ContactDetails'

const { useHistory } = require('react-router-dom')

interface Props {
  
}
const AssoContactsList: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const user = useSelector(state => state.authReducer.user)

  const onFetch = async () => {
    try {
      const prosRef = Fire.store().collection('pros')
      const list = await Fire.list(prosRef.where('showInPartners', '==', true))
      const contacted: any[] = []
      for (const pro of list) {
        const sent = await Fire.doc(prosRef.doc(pro.id).collection('contacts').doc(user.id))
        if (sent && sent.title) {
          sent.pro = pro
          sent.pro_name = pro.name
          sent.pro_offer = pro.offer
          sent.date_col = sent.createdAt ? Time.moment(Fire.getDateFor(sent.createdAt)).format('DD/MM/YYYY HH[h]mm') : '-'
          contacted.push(sent)
        }
      }
      return contacted
    } catch (err) {
      setError("Impossible de charger les partenaires")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }

  return (
    <ListContainer
      title="Demandes de partenariat"
      searchTitle="Rechercher un partenaire..."
      error={error}
      onFetch={onFetch}
      sorting={sorting}
      renderColumns={({ refresh }) => ([
        { name: 'Image', accessor: 'image', cell: (item) => (
          <div className="table-preview">
            {item.pro.logo &&
              <img alt={item.pro.name} src={item.pro.logo} />
            }
          </div>
        ) },
        { name: 'Nom', sortable: true, accessor: 'pro_name' },
        { name: 'Offre', sortable: true, accessor: 'pro_offer' },
        { name: 'Envoyé le', sortable: true, accessor: 'date_col' },
      ])}
      expandableRow={(item: any, { refresh }) => (
        <ContactDetails data={item} refresh={refresh} />
      )}
      />
  );
}

export default AssoContactsList